<ppg-cta-card-template
  class="h-full w-full"
  [url]="informationPageCard().content.pageRelativePath"
  [target]="urlTarget.BLANK"
  [template]="informationPageCardTemplateRef"></ppg-cta-card-template>
<ng-template #informationPageCardTemplateRef>
  <p-card
    [title]="informationPageCard().content.title"
    pAnimateOnScroll
    enterClass="fadein"
    once="false"
    [class.card-max-width]="!isResponsive()"
    class="card-cta-hover card-cta-shadow h-full block animation-duration-2000 animation-ease-in-out information-card">
    <div class="card-title">
      <ppg-card-title [title]="informationPageCard().content.title" class="primary-card-title"></ppg-card-title>
      <ppg-card-arrow-up-right [target]="urlTarget.BLANK"></ppg-card-arrow-up-right>
    </div>
  </p-card>
</ng-template>
